/**
 * Multi-language related operations
 */
import type { LocaleType } from '#/config'

import { i18n } from './setupI18n'
import { unref } from 'vue'
import { loadLocalePool, setHtmlPageLang } from './helper'

// vant多语言
import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'
import zhTW from 'vant/es/locale/lang/zh-TW'

interface LangModule {
  message: Recordable
  dateLocale: Recordable
  dateLocaleName: string
}

export function initVantLocale(lang: LocaleType) {
  const vantLang = lang === 'zh_TW' ? 'zh-TW' : 'en-US'
  const languageType = {
    zh_TW: zhTW,
    en: enUS,
  }
  Locale.use(vantLang, languageType[lang])
}

function setI18nLanguage(locale: LocaleType) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    ;(i18n.global.locale as any).value = locale
  }
  setHtmlPageLang(locale)
}

export function useLocale() {
  // Switching the language will change the locale of useI18n
  // And submit to configuration modification
  async function changeLocale(locale: LocaleType) {
    const globalI18n = i18n.global
    const currentLocale = unref(globalI18n.locale)
    if (currentLocale === locale) {
      return locale
    }

    if (loadLocalePool.includes(locale)) {
      setI18nLanguage(locale)
      return locale
    }
    const langModule = ((await import(`./lang/${locale}.ts`)) as any).default as LangModule
    if (!langModule) return

    const { message } = langModule

    globalI18n.setLocaleMessage(locale, message)
    loadLocalePool.push(locale)

    setI18nLanguage(locale)
    initVantLocale(locale)
    return locale
  }

  return {
    changeLocale,
  }
}
